var MIN_DIGITS = 8;
export default value => {
  if (!value) {
    // no value is a valid phone number in our enquiry form
    return true;
  }
  return /^\+?[0-9 ]+$/.test(value) && value.replace(/ /g, '').length >= MIN_DIGITS;
};